import React from 'react';
import { useParams } from 'react-router-dom';
import CreateRoom from './CreateRoom';

const EditRoom = () => {
  const { id } = useParams();
  return <CreateRoom key={id} roomId={id} />;
};

export default EditRoom;
